import useSWR from "swr";

import * as fetcher from "../fetcher";
import { mutateWithStartKey } from "../mutateWithStartKey";
import { type Opportunity } from "../opportunity/types";

export type AlertType =
  | "ASSIGNED"
  | "TASK_ASSIGNED"
  | "TASK_COMPLETED"
  | "ORDER_BLOCKED"
  | "B2B_ENR_DRAFT_ORDER_STOCK_BACK"
  | "B2B_ENR_DRAFT_ORDER_STOCK_PARTIALLY_BACK";

export interface Alert {
  id: number;
  coworkerEmail?: string;
  createdBy?: string;
  isAcknowledged: boolean;
  priority: number;
  alertType: AlertType;
  createdAt: string;
  updatedAt: string;
}

export interface OpportunityAlert {
  id: number;
  opportunity: {
    opportunityId: number;
    assignedTo: string;
    classification: number;
    amount: number;
    title: string;
    status: Opportunity["status"];
    customerName: string;
    priority: number;
    createdAt: string;
    updatedAt: string;
  };
  coworkerEmail?: string;
  isAcknowledged: boolean;
  priority: number;
  alertsList: Alert[];
}

export const useAlerts = () => {
  return useSWR<OpportunityAlert[]>(
    `/alerts`,
    (url: string) => fetcher.opportunity.get(url),
    {
      revalidateOnFocus: true,
      refreshInterval: 60 * 1000,
    }
  );
};

export const acknowledgeAlert = async (id: number, isAcknowledged: boolean) => {
  return fetcher.opportunity
    .update(`/alerts/${id}`, { isAcknowledged })
    .then(() => {
      mutateWithStartKey(`/alerts`);
    });
};
